/*global $, document, window, setTimeout, alert, typeof, FG*/
(function () {
    "use strict";

    // Delay to show passowrd fields account detail page and auth alert
    var DEFAULT_DELAY = 5000;

    var CSRF_TOKEN = FG.Utils.getToken();

    // Object to manage sign in context
    // It manages whether sign in was triggered by a checkout action
    FG.SignInContext = {

        SIGNIN_CONTEXT_KEY: 'signin_context',
        RESTORE_SIGNIN_CONTEXT_KEY: 'restore_signin_context',
        CHECKOUT_CONTEXT_VALUE: 'checkout',

        clear: function() {
            sessionStorage.removeItem(this.SIGNIN_CONTEXT_KEY);
        },

        /**
         * Set sign in context for checkout flow
         */
        setCheckout: function() {
            sessionStorage.setItem(this.SIGNIN_CONTEXT_KEY, this.CHECKOUT_CONTEXT_VALUE);
        },

        /**
         * Get the current sign in context
         */
        get: function() {
            return sessionStorage.getItem(this.SIGNIN_CONTEXT_KEY);
        },

        /**
         * Check if sign in was triggered by checkout action
         */
        isCheckout: function() {
            return this.get() === this.CHECKOUT_CONTEXT_VALUE;
        },

        /**
         * Preserve sign in context before auto-login after account creation
         */
        preserve: function() {
            var existingContext = this.get();
            if (existingContext) {
                sessionStorage.setItem(this.RESTORE_SIGNIN_CONTEXT_KEY, existingContext);
            }
        },

        /**
         * Restore sign in context if it was preserved during sign up flow
         */
        restore: function() {
            var restoreContext = sessionStorage.getItem(this.RESTORE_SIGNIN_CONTEXT_KEY);
            if (restoreContext) {
                sessionStorage.setItem(this.SIGNIN_CONTEXT_KEY, restoreContext);
                sessionStorage.removeItem(this.RESTORE_SIGNIN_CONTEXT_KEY);
            }
        }
    };

    FG.User = {

        /**
         * Session ID from server. hi jim :)
         * @param {String}
         */
        sessionId: null,

        /**
         * Is this user currently logged in
         * @param {Bool}
         */
        isLoggedIn: false,

        /**
         * User's first name
         * @param {String}
         */
        firstName: null,

        /**
         * User's person id
         * @param {Number}
         */
        personId: null,

        /**
         * Number of seconds till the user's session expires
         * i.e. If they visit the site after these many seconds, they should not see cart expired page.
         * @parsm {Number}
         */
        sessionExpireThresholdSeconds: 3600,

        /**
         * Initialize this object
         * @constructor
         */
        init: function () {
            this.ensureLoginStatusProperty();
            this.ensureNavigationBar();
            this.bindToSignInForm();
            this.bindSignoutLink();
            this.bindToPaymentPlanMangerPayInFull();
            this.bindToPaymentPlanManagerRetryPayment();
            this.ensureCleanSessionExpiry();
            this.bindErrorLink();
            this.bindAuthFormButtonState();
            this.togglePasswordVisibility();
            this.initSignInValidation();
            this.bindToCheckoutAsGuestButton();

            function getUrlParameter(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            }

            // Attempt to show login modal
            // originally only receipt email as ref, added sms , this lets us track where the clicks come from, in theory
            $(function() {
                if (getUrlParameter('ref') === 'email' || getUrlParameter('ref') === 'sms') {
                    if ($('#topNav').hasClass('guest')) {
                        $('#link-global-signin').trigger('click');
                    }
                }
            });

            var $layawayContainer = $('#layawayContainer');
            if ($layawayContainer.length) {
                FGTLibs.userAccountAPICalls().then(function (results) {
                    var props = {
                        containerId: 'layawayContainer',
                        orderId: $layawayContainer.data('orderid'),
                        insuranceCost: $layawayContainer.data('insurancecost'),
                        auth: results[0].braintreeToken,
                        billing: results[0].contactAddress,
                        countryList: results[0].countryList,
                        availablePayments: results[0].availablePayments,
                        locale: (results[0].locale ? results[0].locale.split('.')[0] : 'en_US.utf8'),
                        useCaptcha: results[0].useCaptcha,
                        captchaSiteKey: results[0].captchaSiteKey,
                    };
                    if (results[0].use3DSecure && results[0].locale === 'en_GB.utf8') {
                        // Zero active layaway orders will return an empty array in data
                        // else an object is returned when there is an active layaway order
                        if ( !Array.isArray(results[1].data) ) {
                            props['planAgree'] = results[1].data;
                        }
                    }
                    window.FGTLibs.layawayApp(props);
                });
            }

            var $refundBannerContainer = $('#refundBannerContainer');
            if ($refundBannerContainer.length) {
              window.FGTLibs.renderRefundBanner({
                containerId: 'refundBannerContainer',
                orderId: $refundBannerContainer.data('orderid'),
              });
            }

            var $refundProcessedContainer = $('#refundProcessedContainer');
            if ($refundProcessedContainer.length) {
              window.FGTLibs.renderRefundProcessed({
                containerId: 'refundProcessedContainer',
                orderId: $refundProcessedContainer.data('orderid'),
              });
            }

            var $accountStorePayment = $('#account-store-payment');
            if ($accountStorePayment.length) {
                FGTLibs.userAccountAPICalls().then(function (results) {
                    var props = {
                        containerId: 'account-store-payment',
                        auth: $('#braintree_token').val(),
                        billing: results[0].contactAddress,
                        storedPayment: results[0].storedPayment,
                        countryList: results[0].countryList,
                        availablePayments: results[0].availablePayments,
                        isAccountLocked: results[0].isAccountLocked,
                        locale: (results[0].locale ? results[0].locale.split('.')[0] : 'en_US.utf8'),
                        useCaptcha: results[0].useCaptcha,
                        captchaSiteKey: results[0].captchaSiteKey,
                    };
                    if (results[0].use3DSecure && results[0].locale === 'en_GB.utf8') {
                        // Zero active layaway orders will return an empty array in data
                        // else an object is returned when there is an active layaway order
                        if ( !Array.isArray(results[1].data) ) {
                            props['planAgree'] = results[1].data;
                        }
                    }
                    window.FGTLibs.renderUserAccount(props);
                });
            }

            $('[data-toggle="tooltip"]').tooltip();

            $('.tm-modal-link').click(function(){
                $('#modal-resale').modal();
            });

            $('.open-fulfillment-modal').on('click keypress', function(evt) {
                if (evt.type === 'click' || evt.keyCode === 13) {
                    $('#modal-fulfillment').modal({keyboard: true});
                }
            });
        },

        bindToSignInForm : function() {
            $('#form-signin, #form-checkout-signin').submit(function(e) {
                // Check if we need to restore context (from sign up flow)
                FG.SignInContext.restore();
                return FG.User.handleUserSignIn.call(this, e);
            });
        },

        bindAuthFormButtonState: function() {
            $('#form-signin, #form-signup, #form-forgotpassword, #change-password-form, #my_account_password').on('input', this.setAuthFormButtonState);
        },

        bindErrorLink: function() {
            $('div.billing-error').on('click', 'a.tabswitch', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $("#userSigninTabs a[href='"+ $(this).attr('href') +"']").click();
            });
        },

        initSignInValidation: function () {
            var self = this;
            // if validator exists, remove event listeners and destroy before creating again
            if (self.signInValidation) {
                self.signInValidation.disarm();
                self.signInValidation = null;
            }
            
            var signInValidatorConfig = [
                { id: "txt-login-email", type: ['required'], },
                { id: "txt-login-pass", type: ['required'], },
            ];
            
            var highlightInput = function(element, validation) {
                $(element).closest('.f-input-group')[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).closest('.f-input-group').find('.error-msg')[validation.pass ? 'addClass' : 'removeClass']('hide');
                $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
            };
            
            self.signInValidation = new FGTLibs.InputValidator(signInValidatorConfig, highlightInput);
        },

        /**
         * Handle click event when a user tries to sign in
         * @returns {boolean}
         */
        handleUserSignIn: function (e) {

            var currentForm = $(this),
                email = currentForm.find('#txt-login-email').val(),
                password = currentForm.find('#txt-login-pass').val(),
                Ajax = new FG.AjaxJob('user/signin'),
                $btnUserSingin = currentForm.find(".btn-user-signin"),
                laddaBtnSignIn = new FG.Ladda($btnUserSingin.get(0));
            
            var $alert = FG.User.authAlert(currentForm);

            e.preventDefault();

            FG.Base.initValidateForm(currentForm);
            if (!FG.Base.validateForm(currentForm)){
                return false;
            }

            try {
                if ($alert) {
                    $alert.hide()
                }

                //Disable the signin button
                $btnUserSingin.attr('disabled', 'disabled');

                laddaBtnSignIn.start();

                Ajax.setLaddaButton(laddaBtnSignIn);

                Ajax.setRequestData({
                    email: email,
                    password: password
                });

                Ajax.setSuccessCallback(function (FGResponse) {

                    //Set a login cookie

                    var expDate = new Date();
                    expDate.setTime(expDate.getTime() + (sessionTimeOut*1000));

                    //Set a login type cookie
                    $.cookie("FG_LOGIN_TYPE", 'ExistingAccount', {path: '/'});

                    //Remove the custom cookie
                    $.removeCookie('FG_CUSTOM', {path: '/'});

                    var db = new FG.DB();
                    db.set('activeWaitlistRequest', FGResponse.data.activeWaitlistRequest);

                    // Remove resale parameter after signing in. related to not wanting the TMR instructions modal to appear.
                    var url = new URL(window.location);
                    if (url.searchParams.has('resale')) {
                        url.searchParams.delete('resale');
                        window.history.replaceState({}, '', url.href);
                    }

                    setTimeout(function () {
                        FG.User.redirectAfterSignIn();
                    }, 200);

                });

                Ajax.setFailureCallback(function (FGResponse) {
                    laddaBtnSignIn.stop();
                    if ($alert) {
                        $alert.show({
                            type: 'error',
                            message: FGResponse.msg,
                        });
                    }
                    FG.Base.markFormFieldsInvalid(currentForm);
                    $btnUserSingin.removeAttr('disabled').text(window.FGTLibs.i18n.t('Sign In'));
                    return false;
                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },

        /* Updates the auth form's button state based on whether all required fields are filled. */
        setAuthFormButtonState: function() {
            var $form = $(this);
            var isFormValid = true;
            var formId = $form.attr('id');

            var $alert = FG.User.authAlert($form);
            if ($alert) {
                $alert.hide();
            }

            $form.find('.required:visible').each(function () {
                var $field = $(this);
                var fieldValue = $field.val();

                if (!fieldValue || fieldValue.trim() === '') {
                    isFormValid = false;
                    return false;
                }
            });

            if (isFormValid && formId === 'form-signup') {
                var passwordField = $form.find('.auth-password-field');
                var passwordValue = passwordField.val();
                var isSignUpLegalChecked = $form.find('#sign_up_legal_text').is(':checked');

                if (!FG.Modals.passwordCheck(passwordValue) || !isSignUpLegalChecked) {
                    isFormValid = false;
                }
            }

            $form.find('.auth-button').prop('disabled', !isFormValid);
        },

        initSignupValidation: function () {
            var self = this;
            // if validator exists, remove event listeners and destroy before creating again
            if (self.signupValidator) {
                self.signupValidator.disarm();
                self.signupValidator = null;
            }

            var signupValidatorConfig = [
                { id: "create_firstName", type: ['required', 'noHTML'], },
                { id: "create_lastName", type: ['required', 'noHTML'], },
                { id: "create_email", type: ['required', 'noHTML', 'isEmail'], },
                { id: "create_new_password", type: ['required', 'noHTML'], },
            ];

            var highlightInput = function(element, validation) {
                var msgId = $(element).attr('id').concat('-error');

                if($(element).parents('form').find('div#' + msgId ).length > 0){
                        $(element).attr('aria-describedby', '');
                        $(element).parents('form').find('div#' + msgId ).remove();
                }

                $(element)[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).closest('.f-input-group')[validation.pass ? 'removeClass' : 'addClass']('invalid');
                $(element).closest('.f-input-group').find('.error-msg')[validation.pass ? 'addClass' : 'removeClass']('hide');

                if (!validation.pass && validation.message !== '') {
                    var msgAttr = validation.message.toLowerCase().replace(/\s/g, '_');
                    if($(element).parents('form').find('div#' + msgId).length == 0){
                        $(element).closest('.f-input-group').find('.error-msg').addClass('hide');
                        $(element).attr('aria-describedby', msgId);
                        $(element).parent()
                        .append('<div id="' + msgId + '" class="error-msg invalid" data-msg-text="' + msgAttr + '">' + validation.message + '</div>')
                        .show();
                    }
                    $('#btn-user-create').attr('disabled', true);
                }
            };

            self.signupValidator = new FGTLibs.InputValidator(signupValidatorConfig, highlightInput);
        },

        /**
         * Create a new user
         */
        createNewAccount: function(){

            var self = this,
                firstName = $("#create_firstName").val(),
                lastName = $("#create_lastName").val(),
                email = $("#create_email").val(),
                password = $("#create_new_password").val(),
                lower = new RegExp("[a-z]"),
                upper = new RegExp("[A-Z]"),
                numb = new RegExp("[0-9]"),
                Ajax = new FG.AjaxJob('user/create_account'),
                $btnSignUp = $('#btn-user-create'),
                ladaBtnSignUp = new FG.Ladda($btnSignUp.get(0)),
                formValid = true,
                $signUpForm = $('#form-signup');
            
            var $alert = FG.User.authAlert($signUpForm);
            var $isSignUpLegalChecked = $signUpForm.find('#sign_up_legal_text').is(":checked");

            self.initSignupValidation();
            if(self.signupValidator && !self.signupValidator.checkAll().pass || !$isSignUpLegalChecked) {
                formValid = false;
            }

            if (!lower.test(password) || !upper.test(password) || !numb.test(password) || password.length < 8) {
                $('#create_new_password').addClass('invalid');
                $('label[for="create_new_password"]').addClass('invalid');
                formValid =  false;
            }

            if (formValid) {
                $btnSignUp.attr('disabled', 'disabled');

                ladaBtnSignUp.start();
                try {
                    Ajax.setLaddaButton(ladaBtnSignUp);

                    Ajax.setRequestData({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        password: password
                    });

                    Ajax.setSuccessCallback(function (FGResponse) {

                        $.cookie('FG_LOGIN_TYPE', 'CreateAccount', { path: '/'});

                        if ($alert) {
                            $alert.show({
                                type: 'success',
                                message: FGResponse.msg,
                            });
                        }

                        // Preserve signin context before auto-login
                        FG.SignInContext.preserve();

                        // Log the user in.
                        $('#modal-signin #txt-login-email').val(email).trigger('input');
                        $('#modal-signin #txt-login-pass').val(password).trigger('input');

                        $('#modal-signin .btn-user-signin').click();
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                        ladaBtnSignUp.stop();
                        if ($alert) {
                            $alert.show({
                                type: 'error',
                                message: FGResponse.msg,
                            });
                        }
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            }

            return false;
        },

        /**
         * Manage order as guest
         */
        guestManageOrder: function () {
            //Bind to the guest manage order button
            $('#btn-manage-order').on('click', function (e) {
                e.preventDefault();
                var email = $('#txt-manage-email'),
                    orderId = $('#txt-manage-order-id'),
                    phone = $('#txt-manage-phone'),
                    manageOrderForm = $('#manageorder'),
                    $btnManageOrder = $('#btn-manage-order'),
                    LaddaBtnManageOrder = new FG.Ladda($btnManageOrder.get(0)),
                    Ajax = new FG.AjaxJob('guest/order_lookup'),
                    formValid = true;

                phone.val(phone.val().replace(/[^\+0-9]/g,''));
                FG.Base.initValidateForm(manageOrderForm);
        var requiredValid = FG.Base.validateForm(manageOrderForm);

        if(!requiredValid){
            formValid = false;
        }else{
                    if (!FG.Base.validateEmail(email)) {
                        formValid = false;
                    }
                    if (!FG.Base.validateInteger(orderId)) {
                        formValid = false;
                    }
                    if (!FG.Base.validatePhoneNumber(phone)) {
                        formValid = false;
                    }
        }

                if (formValid) {
                    try {
                        $('#div-manage-error').html('').addClass('hide');

                        //Disable the signin button
                        $btnManageOrder.attr('disabled', 'disabled');

                        LaddaBtnManageOrder.start();

                        Ajax.setLaddaButton(LaddaBtnManageOrder);

                        Ajax.setMessageDiv('#div-manage-error');

                        Ajax.setRequestData({
                            email: email.val(),
                            orderId: orderId.val(),
                            phone: phone.val().replace( "[^\\d]", "" )
                        });

                        Ajax.setSuccessCallback(function (FGResponse) {

                            setTimeout(function () {
                                if (FGResponse.data !== null) {
                                    window.location.href = FGResponse.data.url;
                                } else {
                                    console.log("success and null");
                                }
                            }, 200);
                        });

                        Ajax.setFailureCallback(function (FGResponse) {
                            LaddaBtnManageOrder.stop();
                            $('#div-manage-error').html(FGResponse.msg).removeClass("hide");
                            $btnManageOrder.removeAttr('disabled').text(window.FGTLibs.i18n.t('Look Up'));
                            return false;
                        });

                        Ajax.send();

                    } catch (AjaxException) {
                        Ajax.error(AjaxException.msg);
                    }
                }
        else{
            manageOrderForm.find('input.invalid').first().focus();
        }
            });
        },

        /**
         * Send out a forgot password email message to this user.
         * @param string    url     URL to send this request to
         * @return bool
         */
        sendForgotPasswordEmail: function () {

            var $emailField = $('#txt-forgot-email'),
                Ajax = new FG.AjaxJob('user/forgot_password_form'),
                self = this,
                $btnForgotPassword = $('#btn-forgot-password'),
                LaddaBtnForgotPassword = new FG.Ladda($btnForgotPassword.get(0)),
                $form = $("#form-forgotpassword");

            var $alert = FG.User.authAlert($form);
            if ($alert) {
                $alert.hide()
            }

            if (!FG.Base.validateForm($form)){
                return false;
            }


            if (!FG.Base.validateEmail($emailField)) {
                $form.find('.error-msg').addClass('hide');
                if ($alert) {
                    $alert.show({
                        type: 'error',
                        message: window.FGTLibs.i18n.t('auth.invalid.email'),
                        autoHide: true,
                    });
                }
                return false;
            }

            // Reject emails containing quotes (RFC allows them, but not supported)
            var emailValue = $emailField.val();
            if (/['"]/.test(emailValue)) {                                                                                                                                                              
                $form.find('.error-msg').addClass('hide');
                if ($alert) {                                                                                                                                                                           
                    $alert.show({                                                                  
                        type: 'error',
                        message: window.FGTLibs.i18n.t('auth.invalid.email.quotes'),
                        autoHide: true,
                    });
                }
                return false;
            }

            $btnForgotPassword.attr('disabled', 'disabled');

            LaddaBtnForgotPassword.start();

            Ajax.setLaddaButton(LaddaBtnForgotPassword);

            try {
                Ajax.setRequestData({
                    email: $emailField.val()
                });

                Ajax.setSuccessCallback(function() {
                    LaddaBtnForgotPassword.stop();
                    if ($alert) {
                        $alert.show({
                            type: 'success',
                            message: window.FGTLibs.i18n.t('auth.password.link.sent'),
                            autoHide: true,
                        });   
                    }
                    $('#div-forgot-instructions').addClass('hidden');
                    $('#div-forgot-response').removeClass('hidden');
                    FG.User.enableClickToManageOrder();
                    $btnForgotPassword.prop('disabled', true);
                    $emailField.prop('disabled', true);
                });

                Ajax.setFailureCallback(function(error) {
                    LaddaBtnForgotPassword.stop();
                    // Security measure: If the email is not found in the DB,
                    // still show "Password reset link has been sent" to avoid
                    // revealing whether the account exists.
                    
                    var alertConfig = error.msg === 'Sorry, Mail not sent.' ? {
                        message: window.FGTLibs.i18n.t('auth.password.link.sent'),
                        type: 'success'
                    } : {
                        message: error.msg,
                        type: 'error'
                    };
                    if ($alert) {
                        $alert.show({
                            type: alertConfig.type,
                            message: alertConfig.message,
                            autoHide: true,
                        });
                    }
                    // show forgot response text and hide forgot instructions and enable manageorder form
                    $('#div-forgot-instructions').addClass('hidden');
                    $('#div-forgot-response').removeClass('hidden');
                    FG.User.enableClickToManageOrder();
                });

                Ajax.setShowEmailSentMessage(true);
                Ajax.send();
            } catch (AjaxException) {
                LaddaBtnForgotPassword.stop();
                Ajax.error(AjaxException.msg);
            }

            return false;
        },

        /**
         * Update a user's password
         * @param string url handler
         * @return bool
         */
        updatePassword: function () {
            var $form = $("#my_account_password");
            var $oldPassword = $("#inputOldPassword");
            var $newPassword = $("#inputNewPassword");
            var $submitButton = $("#btn-submit-password");

            var Ajax = new FG.Ajax('user/update_password');
            var LaddaBtnUpdate = new FG.Ladda($submitButton[0]);
            var isFormValid = true;

            var $alert = FG.User.authAlert($form);
            if ($alert) {
                $alert.hide();
            }

            FG.Base.initValidateForm($form);
            if(!FG.Base.validateForm($form)) {
                $form.find('.error-msg').addClass('invalid');
                isFormValid = false
            }

            if (!FG.Modals.passwordCheck($newPassword.val())) {
                $newPassword.addClass("invalid");
                $form.find('.error-msg').addClass('invalid');
                $("label[for='inputNewPassword']").addClass("invalid");
                isFormValid = false;
            }

            if (!isFormValid) {
                return;
            }

            try {
                LaddaBtnUpdate.start();
                Ajax.setRequestData({
                    oldPassword: $oldPassword.val(),
                    newPassword: $newPassword.val(),
                    csrf_token : CSRF_TOKEN
                });

                Ajax.setSuccessCallback(function (FGResponse) {
                    if ($alert) {
                        $alert.show({
                            type: 'success',
                            message: FGResponse.msg,
                            autoHide: true
                        });
                    }

                    setFormStateAfterSuccess();
                    
                    LaddaBtnUpdate.stop();
                    
                    setTimeout(function () {
                        resetPasswordForm();
                    }, DEFAULT_DELAY);

                    function setFormStateAfterSuccess() {
                        $oldPassword.val("");
                        $newPassword.val("");

                        $submitButton.hide();
                        $form.find(".password-info").hide();
                        $form.find(":input")
                            .blur()
                            .removeClass('invalid')
                            .prop('disabled', true);
                        $form.find(".toggle-password")
                            .removeClass('eye-closed')
                            .addClass('eye-open');
                        $form.find('.error-msg').addClass('hide');
                        $form.find("label").removeClass('invalid');
                    }

                    function resetPasswordForm() {
                        $form.find(".password-info").show();
                        $form.find(".auth-password-rules li")
                            .removeClass("valid")
                            .find("span").removeClass("highlight");
                        $form.find(":input").prop("disabled", false);
                        $submitButton.show().prop("disabled", true);
                        $form.find(".auth-password-field").attr('type', 'password');
                    }
                });

                Ajax.setFailureCallback(function (FGResponse) {
                    var message = '';
                    if (FGResponse.msg === "Old Password is incorrect") {
                        message = window.FGTLibs.i18n.t('Current Password is incorrect');
                        $oldPassword.addClass("invalid");
                        $("label[for='inputOldPassword']").addClass("invalid");
                    } else if (FGResponse.errorType === 'SessionException') {
                        message = window.FGTLibs.i18n.t(FGResponse.msg);
                    }

                    if ($alert) {
                        $alert.show({
                            type: 'error',
                            message: message || FGResponse.msg,
                            autoHide: true
                        });
                    }

                    LaddaBtnUpdate.stop();
                    return false;
                });

                Ajax.send();


            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },

        /**
         * Save user's account information
         * @return void
         */
        saveContactInfo: function () {
            var laddaBtnUpdate = new FG.Ladda($('#btn-submit-account')[0]);

            // One-shot latch for the OTP step-up re-prompt below. The verified
            // resubmit can itself come back otpRequired — the session flag is
            // consumed on a successful save, so a save that then fails for an
            // unrelated reason leaves the gate closed again. Without this, the
            // failure callback reopens the prompt on every cycle and the fan
            // cannot reach the real error message underneath it.
            var hasPromptedForOtp = false;

            FG.Base.initValidateForm($('#my_account_contact'));
            if (!FG.Base.validateForm($('#my_account_contact'))) {
                return false;
            }

            const countryCode = FG.Utils.getCountryCode("#phone-intl");
            const phoneNumber = $('#intl-phone-input').val().trim();

            if (!countryCode.length || !phoneNumber.length) {
                $('#phone-intl input[type="tel"]').addClass('invalid');
                $('#missing_phone_error').removeClass('hidden');
                $('#phone_error').addClass('hidden');
                return;
            }

            var validatePhoneOptions = {
                path: 'util/validate',
                parameters: { phone: countryCode + phoneNumber },
                wait: 0,
            };

            resetServerErrors();
            laddaBtnUpdate.start();
            FGTLibs.API.post(validatePhoneOptions)
                .then(function (result) {
                    if (result && !result.valid) {
                        throw Error('server_invalid_phone');
                    }

                    $('#my_phone').val(result.phone_number);

                    submitContactInfo();
                })
                .catch(function (error) {
                    laddaBtnUpdate.stop();

                    if (error.message === 'server_invalid_phone') {
                        $('#phone-intl input[type="tel"]').addClass('invalid');
                        $('#missing_phone_error').addClass('hidden');
                        $('#phone_error').removeClass('hidden');
                        return;
                    }

                    window.location.reload();
                });

            function resetServerErrors() {
                $('#phone_error, #missing_phone_error').addClass('hidden');
            }

            function disableFormInteraction($form, $submitButton) {
                $form.find(':input').prop('readonly', true);
                $submitButton.hide();
            }
            
            function enableFormInteraction($form, $submitButton) {
                $form.find(':input').prop('readonly', false);
                $submitButton.show();
            }            

            function submitContactInfo() {
                var firstName = $('#my_firstName').val();
                var lastName = $('#my_lastName').val();
                var email = $("#my_email").val();
                var phone = $("#my_phone").val();
                var profileOptOut = $("#my_profile_opt_out").prop('checked');
                var Ajax = new FG.Ajax('user/contact');
                
                var $alert = $('#div-error-contact');
                var $form = $("#my_account_contact");
                var $submitButton = $('#btn-submit-account');

                laddaBtnUpdate.start();

                try {
                    Ajax.setRequestData({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phone: phone,
                        profileOptOut: profileOptOut,
                        csrf_token: CSRF_TOKEN
                    });

                    Ajax.setSuccessCallback(function (FGResponse) {
                        laddaBtnUpdate.stop();

                        $alert.html(FGResponse.msg).removeClass('text-danger').addClass('text-success');

                        disableFormInteraction($form, $submitButton);

                        setTimeout(function () {
                            $alert.html(FGResponse.msg).empty();
                            enableFormInteraction($form, $submitButton);
                        }, 5000);
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                        laddaBtnUpdate.stop();

                        // OTP step-up on email change: verify,
                        // then resubmit the same form data. Latched so a
                        // resubmit that comes back otpRequired again surfaces
                        // its error instead of looping the prompt.
                        if (FGResponse && FGResponse.data && FGResponse.data.otpRequired
                            && FG.Otp && !hasPromptedForOtp) {
                            hasPromptedForOtp = true;
                            $alert.empty();
                            FG.Otp.prompt('email_change', function () {
                                submitContactInfo();
                            });
                            return;
                        }

                        $alert.html(FGResponse.msg).removeClass('text-success').addClass('text-danger');
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            }
        },

        /**
         * Prime
         */
        bindSignoutLink: function () {

            var self = this;

            $('#sign_out').unbind('click').bind('click', function (e) {

                e.preventDefault();

                $('#modal-signout').modal({
                    show: true,
                    backdrop: true,
                    keyboard: true
                }).animate({
                    top: $(window).height() / 2 - $('#modal-signout').height() / 2
                }, 'fast');

                self.logout();

                return false;
            });
        },

        bindToPaymentPlanMangerPayInFull: function () {

            $('#btn-pay-in-full').unbind('click').bind('click', function () {

                var self = this;
                var origText = $(self).text();

                $(self).attr('disabled', 'disabled').text(window.FGTLibs.i18n.t('Please wait...'));

                if(confirm('Are you sure you want to pay '+$(this).data('balance')+' in full?\n')){


                    var xOrderId = $(this).data('xorderid');

                    var Ajax = new FG.Ajax('user/payment_plan_pay_in_full');

                    Ajax.setMessageDiv('#div-msg-payment-plan');

                    Ajax.setRequestData({ xOrderId: xOrderId });

                    Ajax.setSuccessCallback(function (FGResponse) {
                        if (FGResponse.error == 0) {
                            window.location.reload();
                        }
                    });

                    Ajax.setFailureCallback(function(FGResponse){
                        $(self).removeAttr('disabled').text(origText);
                    });

                    Ajax.send();
                } else {
                    $(self).removeAttr('disabled').text(origText);
                }
            });
        },

        /**
         * Bind to the retry failed payment button for a layaway plan with a failed step
         */
        bindToPaymentPlanManagerRetryPayment : function() {

            $('.cls-btn-retry-step').unbind('click').bind('click', function() {

                var self = this;
                var origText = $(self).text();
                $(self).attr('disabled', 'disabled').text(window.FGTLibs.i18n.t('Please wait...'));

                if(confirm('Are you sure you want to pay '+ $(this).data('payment') +'?\n')){
                    var paymentPlanStepId = $(this).data('paymentplanstepid');
                    var xOrderId = $(this).data('xorderid');

                    var Ajax = new FG.Ajax('user/payment_plan_retry_failed_payment');

                    Ajax.setRequestData(
                        {
                            'paymentPlanStepId' : paymentPlanStepId,
                            'xOrderId' : xOrderId
                        }
                    );

                    Ajax.setMessageDiv('#div-msg-payment-plan');

                    Ajax.setSuccessCallback(function(FGResponse){
                        window.location.reload();
                    });

                    Ajax.setFailureCallback(function(FGResponse){
                        $(self).removeAttr('disabled').text(origText);
                    });

                    Ajax.send();
                } else {
                    $(self).removeAttr('disabled').text(origText);
                }
            });
        },

        /**
         * Ensure that this user does not encounter a cart expired page if they visit the site after a while
         */
        ensureCleanSessionExpiry: function () {

            /**
             * Local DB Object
             * @type {window.FG.DB}
             */
            var db = new FG.DB();

            /**
             * Last UNIX timestamp of any user activity
             * @type {Number}
             */
            var lastActivityTS = db.get('lastActivityTS');

            /**
             * Current UNIX Timestamp
             * @type {Number}
             */
            var currentTS = FG.Base.getCurrentTimestamp();

            //If the difference between the last activity and the current time is greater than the threshold
            if ( (lastActivityTS != null && typeof lastActivityTS != 'undefined') && ((currentTS - lastActivityTS) > this.sessionExpireThresholdSeconds )) {

                //Inactivate the cart
                db.remove('cartActive');
                db.remove('totalCount');
                db.remove('promoCode');
                //Delete the cart timer
                FG.CartTimer.deleteTimer();

                //Delete the cart
                FG.Cart.deleteCart(true);

                // Remove cart tracking data
                FG.tradableBits().removeCartData();

                //Initialize the cart
                FG.Cart.init();

                //Initialize the timer
                FG.CartTimer.init();

                //Reset activity
                db.set('lastActivityTS', currentTS);

            } else {
                //Reset Activity
                db.set('lastActivityTS', FG.Base.getCurrentTimestamp());
            }
        },

        /**
         * Log a user out
         */
        logout: function () {

            var Ajax = new FG.Ajax('user/signout');

            try {

                // Pause cart timer immediately to prevent race condition
                // This stops the timer from firing delete_cart requests
                // with stale CSRF tokens after session is destroyed
                FG.CartTimer.pauseTimer();

                Ajax.setSuccessCallback(function (FGResponse) {

                    //Nuke all the timeouts in the local database
                    var db = new FG.DB();

                    db.remove('cartExpiry');
                    db.remove('totalCount');
                    db.remove('sessionExpiry');
                    db.set('cartActive', 0);
                    db.nuke();

                    $.removeCookie('FG_LOGGED_IN', { path: '/' });
                    $.removeCookie('FG_AUTH', { path: '/' });
                    $.removeCookie('FG_CUSTOM', { path: '/' });
                    $.removeCookie('FG_LOGIN_TYPE', { path: '/' });

                    var location = FGResponse.data.location;

                    if (typeof location == 'undefined' || location == null || location == 'null' || typeof location == null) {
                        window.location.reload();
                    } else {
                        window.location.href = location;
                    }

                    return false;
                });

                Ajax.setFailureCallback(function () {
                    return false;
                });

                Ajax.setRequestData({csrf_token: CSRF_TOKEN});
                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }

        },

        /**
         * Initialize a user's session
         */
        ensureSessionCookie: function () {
            var sessid = $.cookie('FG_SESSID');
            if (!sessid) {
                var expDate = new Date();
                expDate.setTime(expDate.getTime() + (sessionTimeOut*1000));
                //use jquery.uuid.js to generate uuid
                sessid = $.uuid();
                $.cookie('FG_SESSID', sessid, { path: '/', expires: expDate });
            }
            this.sessionId = sessid;
        },

        /**
         * Initialize the user's logged in status and personId
         */
        ensureLoginStatusProperty: function () {
            this.isLoggedIn = $.cookie('FG_LOGGED_IN') ? true : false;
            this.personId = (PERSON_ID ? PERSON_ID : null);
        },

        /**
         * Initialize the nav bar
         */
        ensureNavigationBar: function () {

            if ($.cookie('FG_LOGGED_IN') == 1) {

                var db = new FG.DB(),
                    picture = db.get('picture'),
                    firstName = db.get('firstName'),
                    fgCustom = $.cookie('FG_CUSTOM') ? JSON.parse($.cookie('FG_CUSTOM')) : null;

                //Check to see if this user selected "continue as guest"
                if (fgCustom != null && (fgCustom.isGuest && fgCustom.isGuest == 1) ||
                    (fgCustom != null && fgCustom.hasOwnProperty('tmpPersonId') && fgCustom.tmpPersonId != null)) {
                    $('#topNav').addClass('guest');
                } else {
                    if (typeof picture != 'undefined' && picture != null) {
                        picture = picture.replace('http:', '').replace('https:', '');
                        $("#span-your-account").addClass('fb').html('<img src="' + picture + '" class="fb-profile-pic" /> ' + firstName + ' <span class="down_caret">&#9660;</span>');
                    }

                    $('#topNav').removeClass('guest');
                }
            } else {
                $('#topNav').addClass('guest');
            }
        },

        getSessionExpireThresholdSeconds: function () {
            return this.sessionExpireThresholdSeconds;
        },

        enableClickToManageOrder: function () {
            $('#manage_order_forgot_password').on('click', function () {
                $('#modal-manage').modal('show');
                $("#modal-signin").modal("hide");
            });
        },
        togglePasswordVisibility: function() {
            $('.toggle-password').off('click.togglePassword').on('click.togglePassword', function () {
                var $toggleButton = $(this);
                var targetId = $toggleButton.data('target');
                var $field = $('#' + targetId);

                if (!$field.length) {
                    return;
                }

                var isPassword = $field.attr('type') === 'password';
                var toggleLabel = isPassword ? window.FGTLibs.i18n.t('Hide Password') : window.FGTLibs.i18n.t('Show Password');
                var toggleEyeClass = isPassword ? 'eye-closed' : 'eye-open';

                $field.attr('type', isPassword ? 'text' : 'password');
                $toggleButton
                    .removeClass('eye-closed eye-open')
                    .addClass(toggleEyeClass)
                    .attr('aria-label', toggleLabel);
            });
        },

        authAlert: function ($form) {
            if (!$form) {
                console.warn('Auth Alert handler: Missing $form element.');
                return;
            }
            var $alert = $form.find('.auth-alert');
            if (!$alert.length) {
                console.warn('Auth Alert handler: Missing .auth-alert element.');
                return;
            }

            $alert.removeClass('error success');
            var autoHideTimer = null;

            return {
                show: function (option) {
                    option = option || {};
                    var type = option.type || 'error';
                    var message = option.message || '';
                    var autoHide = option.autoHide === true;
                    var delay = option.delay || DEFAULT_DELAY;

                    if (autoHideTimer) {
                        clearTimeout(autoHideTimer);
                        autoHideTimer = null;
                    }

                    $alert
                        .removeClass('error success hide')
                        .addClass(type)
                        .text(message);

                    if (autoHide) {
                        autoHideTimer = setTimeout(function () {
                            $alert
                                .addClass('hide')
                                .text('');
                        }, delay);
                    }
                },
                hide: function() {
                    if (autoHideTimer) {
                        clearTimeout(autoHideTimer);
                        autoHideTimer = null;
                    }

                    $alert
                        .addClass('hide')
                        .text('');
                }
            }
        },
        handleCheckoutWithSignInModal: function ($hideModal) {
            if(!FG.User.isLoggedIn) {
                // Set context before showing modal
                FG.SignInContext.setCheckout();
                $('#modal-signin').modal('show');
                $('#guest-checkout-container').removeClass('hide');
                $hideModal.modal('hide');
            } else {
                window.location.href = $('#labelRoot').val() + '/checkout';
            }
        },
        bindToCheckoutAsGuestButton: function () {

            //Bind to the checkout as guest button
            $('#btn-checkout-guest').on('click', function (e) {

                e.preventDefault();
                
                var $form = $("#form-signin");
                var $alert = FG.User.authAlert($form);

                var Ajax = new FG.Ajax('checkout/checkout_as_guest');

                try {

                    if ($alert) {
                        $alert.hide()
                    }

                    Ajax.setSuccessCallback(function (FGResponse) {

                        //Set login type cookie
                        $.cookie('FG_LOGIN_TYPE', 'Guest', {path: '/'});

                        setTimeout(function () {
                            if (FGResponse.data !== null) {
                                window.location.href = FGResponse.data.url;
                            } else {
                                window.location.reload();
                            }
                        }, 200);
                    });

                    Ajax.setFailureCallback(function (FGResponse) {
                        if ($alert) {
                            $alert.show({
                                type: 'error',
                                message: FGResponse.msg,
                            });
                        }
                    });

                    Ajax.send();

                } catch (AjaxException) {
                    Ajax.error(AjaxException.msg);
                }
            });
        },

        /**
         * Handle redirect logic after successful sign in
         */
        redirectAfterSignIn: function() {
            var pathname = window.location.pathname;
            var labelRoot = document.getElementById('labelRoot').value;
            var shouldRedirectToCheckout = FG.SignInContext.isCheckout();

            FG.SignInContext.clear();

            // If on the forgot password page, redirect to the main label page
            if (pathname.indexOf('/user/forgot_password') === 0) {
                window.location.replace(window.location.origin);
                return;
            }

            // If on an event, package, or cart page,
            // check context to determine whether to redirect to checkout
            if ( pathname.indexOf('/event/') === 0 
                || pathname.indexOf('/package/') === 0
                || pathname.indexOf('/cart') === 0 )
            {
                // Only redirect to checkout if sign in was triggered by checkout action
                if (shouldRedirectToCheckout) {
                    window.location.href = labelRoot + '/checkout';
                    return;
                }

                window.location.reload();
                return;
            }

            window.location.reload();
        },
    };
}());
